'use client';

import React, { useContext } from 'react'; 
import MenuItem from '@mui/material/MenuItem';

import { authClient } from '@/lib/auth/custom/client';
import { logger } from '@/lib/default-logger';
import { useUser } from '@/hooks/use-user';
import { toast } from '@/components/core/toaster';
import DataContext from '@/contexts/DataContext';

export function CustomSignOut() {
  const { checkSession } = useUser();
  const { projects, appsAndViews, setSelectedViewParams, currentProject, setCurrentAlert, setHistorianParams } = useContext(DataContext);

  const handleSignOut = React.useCallback(async () => {
    try {
      clearData();
      const { error } = await authClient.signOut();

      if (error) {
        console.error('Sign out error', error);
        toast.error('Something went wrong, unable to sign out');
        return;
      }

      // Refresh the auth state
      await checkSession?.();
      // After refresh, GuestGuard will handle the redirect
    } catch (err) {
      console.error('Sign out error', err);
      toast.error('Something went wrong, unable to sign out');
    }
  }, [checkSession]);

  const clearData = () => {
    // localStorage.clear();
    // clear last used
    for (const project of projects) {
      localStorage.removeItem(`lastUsedAlert-${project.id}`);
      localStorage.removeItem(`lastUsedHistorian-${project.id}`);
    }

    for (const app of appsAndViews) {
      localStorage.removeItem(`lastUsedParams-${app.id}`);
    }
    setSelectedViewParams({});
    setCurrentAlert(null);
    setHistorianParams({});
  }

  return (
    <MenuItem component="div" onClick={handleSignOut} sx={{ justifyContent: 'center' }}>
      Sign out
    </MenuItem>
  );
}
